import { styled, Box } from '@mui/material';

export const GeneralDatepickerStyled = styled(Box)(() => ({
  position: 'relative',
}));
